import { motion } from "framer-motion";
import { useLang, waLink } from "@/lib/i18n";

export default function WhatsAppFab() {
  const { t } = useLang();
  return (
    <motion.a
      data-testid="whatsapp-floating-button"
      href={waLink(t.waDefault)}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.8, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.45)] sm:bottom-8 sm:right-8 sm:h-16 sm:w-16"
    >
      <span className="ping-ring absolute inset-0 rounded-full bg-[#25D366]" />
      <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-current" aria-hidden="true">
        <path d="M16.04 3C9 3 3.3 8.7 3.3 15.74c0 2.25.6 4.45 1.72 6.38L3.2 29l7.05-1.78a12.7 12.7 0 0 0 5.79 1.4h.01c7.03 0 12.74-5.71 12.74-12.75C28.79 8.7 23.08 3 16.04 3Zm0 23.47h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.18 1.06 1.12-4.07-.25-.42a10.57 10.57 0 0 1-1.62-5.6c0-5.85 4.77-10.62 10.64-10.62 5.86 0 10.62 4.77 10.62 10.63 0 5.86-4.77 10.63-10.53 10.63Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.3-.1-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.08 1.3 3.3.16.2 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.46.2 2 .12.61-.09 1.89-.77 2.15-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z" />
      </svg>
    </motion.a>
  );
}
